export default __webpack_public_path__ + "static/media/mail-bounced-gray.27f6f474.svg";